import React from 'react';
import {Formik, Field, Form} from 'formik';
import {
    CustomDropdownComponent,
    CustomRadioCheckComponent
} from 'components/RenderInput';

const GamesFilterForm = ({teamsOptions, onFilterGames, scheduleOptions}) => {
    return (
        <Formik
            id="eventGamesFilterForm"
            initialValues={{category: 0}}
            onSubmit={onFilterGames}
        >
            <Form>
                <div className={'display-flex '}>
                    <div className={'padding-small'}>
                        <Field
                            name="teamId"
                            component={CustomDropdownComponent}
                            label={'Team'}
                            options={teamsOptions}
                            submitOnChange
                        />
                    </div>
                    <div className={'padding-small'}>
                        <Field
                            name="scheduleId"
                            component={CustomDropdownComponent}
                            label={'Day'}
                            options={scheduleOptions}
                            submitOnChange
                        />
                    </div>
                    <div className={'display-flex checkbox-container'}>
                        <Field
                            name="category" type={'radio'} value={0}
                            component={CustomRadioCheckComponent}
                            label={'All'}
                            submitOnChange
                        />
                        <Field
                            name="category" type={'radio'} value={1}
                            component={CustomRadioCheckComponent}
                            label={'Men'}
                            submitOnChange
                        />
                        <Field
                            name="category" type={'radio'} value={2}
                            component={CustomRadioCheckComponent}
                            label={'Women'}
                            submitOnChange
                        />
                    </div>
                </div>
            </Form>
        </Formik>
    
    );
};

export default GamesFilterForm;